import { TableCell } from "@mui/material";
import React, { FC } from "react";
import { EMPTY_STRING } from "../../../common/constants/common.constants";
import { clubRowCell } from "../DashboardTable/TableHeading/TableHeading.styles";
import clubAvatar from "../../../assets/clubAvatar.png";
import "./ClubTableCell.scss";

const ClubTableCell: FC<{ clubName: string; clubImageUrl: string }> = ({
  clubImageUrl,
  clubName,
}) => {
  return (
    <TableCell style={{ ...clubRowCell, opacity: "1" }}>
      <div className="club-table-cell">
        <img
          src={
            clubImageUrl && clubImageUrl !== EMPTY_STRING
              ? clubImageUrl
              : clubAvatar
          }
          alt="clubImage"
        />
        <p>{clubName}</p>
      </div>
    </TableCell>
  );
};

export default ClubTableCell;
